import React from 'react';
import { motion } from 'motion/react';
import {
  fadeUp,
  fadeIn,
  scaleIn,
  sharedAxisX,
  staggerContainer,
  staggerItem,
  VIEWPORT_ONCE,
  withDelay,
} from '../../utils/motion';

const VARIANTS = { fadeUp, fadeIn, scaleIn, sharedAxisX };

const getTag = (as) => motion[as] || motion.div;

/**
 * Revela su contenido al entrar en el viewport (whileInView).
 * Sustituye al hook useReveal en componentes nuevos; solo anima opacity/transform.
 */
export const Reveal = React.forwardRef(function Reveal(
  {
    as = 'div',
    variant = 'fadeUp',
    delay = 0,
    viewport = VIEWPORT_ONCE,
    className,
    children,
    ...props
  },
  ref
) {
  const Tag = getTag(as);
  const variants = withDelay(
    typeof variant === 'string' ? VARIANTS[variant] || fadeUp : variant,
    delay
  );
  return (
    <Tag
      ref={ref}
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
      {...props}
    >
      {children}
    </Tag>
  );
});

/**
 * Contenedor que escalona la entrada de sus <StaggerItem> hijos.
 */
export const Stagger = React.forwardRef(function Stagger(
  {
    as = 'div',
    stagger = 0.07,
    delay = 0,
    viewport = VIEWPORT_ONCE,
    className,
    children,
    ...props
  },
  ref
) {
  const Tag = getTag(as);
  return (
    <Tag
      ref={ref}
      className={className}
      variants={staggerContainer(stagger, delay)}
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
      {...props}
    >
      {children}
    </Tag>
  );
});

export const StaggerItem = React.forwardRef(function StaggerItem(
  { as = 'div', className, children, ...props },
  ref
) {
  const Tag = getTag(as);
  return (
    <Tag ref={ref} className={className} variants={staggerItem} {...props}>
      {children}
    </Tag>
  );
});
